import { render, staticRenderFns } from "./TalentModule.vue?vue&type=template&id=3fdd9262"
import script from "./TalentModule.vue?vue&type=script&lang=ts"
export * from "./TalentModule.vue?vue&type=script&lang=ts"
import style0 from "./TalentModule.vue?vue&type=style&index=0&id=3fdd9262&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports